<template>
  <div class="zj-router-view">
    <div style="display: none">{{ pluginUrl }}</div>
    <component v-if="!!cmp" v-bind="viewData" :is="cmp"></component>
    <div class="zj-errmsg" v-else>
      <span>{{ errmsg }}</span>
    </div>
  </div>
</template>

<script>
import iFrame from "./iFrame";
import utils from "../utils";
import ZJPlugins from "../plugins";

export default {
  name: "ZjRouterView",
  data() {
    return {
      errmsg: "",
      cmp: null,
      viewData: null,
      pluginUrl: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.updateView(
        vm.$route.path,
        vm.$route.query || {},
        vm.$route.fullPath,
        vm.$route.hash
      );
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.updateView(to.path, to.query || {}, to.fullPath, to.hash);
    next();
  },

  methods: {
    updateView(path, query, fullPath, hash) {
      if (!path) {
        return;
      }
      let menu = null;
      if (utils.startsWith(path.toLowerCase(), "/plugin/")) {
        let url = "plugin://" + path.substr("/plugin/".length);
        menu = this.menu.findMenuByMenuUrl(url);
        if (!menu) {
          this.updateViewByUrl(url, {
            fullPath: fullPath,
            path: path,
            query: query,
            hash: hash,
            menu: undefined,
            targetUrl: url,
          });
        } else {
          this.$router.gotoMenu(menu, query);
        }
        return;
      } else if (utils.startsWith(path.toLowerCase(), "/mobile/plugin/")) {
        let url = "plugin://" + path.substr("/mobile/plugin/".length);
        menu = this.menu.findMenuByMenuUrl(url);
        if (!menu) {
          this.updateViewByUrl(url, {
            fullPath: fullPath,
            path: path,
            query: query,
            hash: hash,
            menu: undefined,
            targetUrl: url,
          });
        } else {
          this.$router.gotoMenu(menu, query);
        }
        return;
      } else if (utils.startsWith(path.toLowerCase(), "/m/")) {
        let url = "plugin://" + path.substr("/m/".length);
        menu = this.menu.findMenuByMenuUrl(url);
        if (!menu) {
          this.updateViewByUrl(url, {
            fullPath: fullPath,
            path: path,
            query: query,
            hash: hash,
            menu: undefined,
            targetUrl: url,
          });
        } else {
          this.$router.gotoMenu(menu, query);
        }
        return;
      } else {
        // 从菜单中加载
        menu = this.menu.findMenuByRoutePath(path);
      }

      if (!menu) {
        this.notFound();
        return;
      }
      if (window.history && window.history.pushState) {
        if (!menu.$parent || menu.$parent == this.$menu) {
          this.selectNavMenu(menu);
        } else {
          let nav = this.menu.findNavMenu(menu);
          if (nav) {
            this.selectNavMenu(nav);
          }
          this.selectMenu(menu);
        }
      }

      let url = menu.MenuUrl;
      this.updateViewByUrl(url, {
        fullPath: fullPath,
        path: path,
        query: query,
        hash: hash,
        menu: menu,
        targetUrl: url,
      });
    },

    updateViewByUrl(url, data) {
      if (!url) {
        return;
      }

      this.pluginUrl = url;

      // 打开外部网页
      if (
        utils.startsWith(url.toLowerCase(), "http://") ||
        utils.startsWith(url.toLowerCase(), "https://")
      ) {
        this.errmsg = url;
        this.viewData = {
          url,
          data,
        };
        this.cmp = iFrame;
        return;
      }

      // 解析插件路径
      if (utils.startsWith(url.toLowerCase(), "plugin://")) {
        ZJPlugins.getComponent(url)
          .then((d) => {
            if (!d || !d.component) {
              this.notFound();
              return;
            } else {
              data = data || {};
              data.targetUri = d.uri;
              this.errmsg = "";
              this.viewData = data;
              this.cmp = d.component;
            }
          })
          .catch((e) => {
            console.error(e);
            this.errmsg = "地址解析失败: " + url + "。" + e;
            this.cmp = null;
          });

        return;
      }

      this.errmsg = "";
      this.viewData = null;
      this.cmp = null;
      let newUrl;

      if (url[0] == "/") {
        newUrl = window.location.protocol + "//" + window.location.host + url;
      } else {
        newUrl = window.location.href;
        let index = newUrl.indexOf("#");
        if (index != -1) {
          newUrl = newUrl.substr(0, index);
        }
        index = newUrl.indexOf("?");
        if (index != -1) {
          newUrl = newUrl.substr(0, index);
        }
        index = newUrl.lastIndexOf("/");
        if (index != -1) {
          newUrl = newUrl.substr(0, index);
        }
        if (newUrl[newUrl.length - 1] != "/") {
          newUrl += "/";
        }
        newUrl += url;
      }

      this.errmsg = "Jump to " + newUrl;
      window.location.href = newUrl;
    },

    // 404 Not Found
    notFound() {
      this.errmsg = "404 Not Found";
      this.viewData = null;
      this.cmp = null;
    },
    selectNavMenu(menu) {
      let root = this.menu || {};
      let find = null;
      utils.each(root.MenuInfos || [], (x) => {
        const isActive = x.MenuId == menu.MenuId;
        this.$set(x, "isActive", isActive);
        if (isActive) {
          find = x;
        }
      });
      root.currentNavMenu = find;
    },
    selectMenu(menu) {
      let root = this.menu || {};
      root.currentMenu = menu;
    },
  },
};
</script>
